module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button field is-danger",
    attrs: {
      "disabled": !_vm.selected
    },
    on: {
      "click": function($event) {
        _vm.selected = null
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "close"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Clear selected")])], 1), _vm._v(" "), _c('b-tabs', [_c('b-tab-item', {
    attrs: {
      "label": "Table"
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "selected": _vm.selected,
      "focusable": ""
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      }
    }
  })], 1), _vm._v(" "), _c('b-tab-item', {
    attrs: {
      "label": "Selected"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.selected))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-672534a6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExSelection.vue
// module id = 1203
// module chunks = 1 84